import "./App.css";
import Home from "./components/Home";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import restaurantService from "./services/RestaurantServices";

const RESTAURANT_ID = "698c86d6f7a68b9cdb6c4e34";

function App() {
  const [restaurantData, setRestaurantData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showIntro, setShowIntro] = useState(true);

  const refreshRestaurantData = () =>
    restaurantService.getRestaurantById(RESTAURANT_ID).then(setRestaurantData);

  useEffect(() => {
    const dataPromise = restaurantService
      .getRestaurantById(RESTAURANT_ID)
      .then((res) => {
        setRestaurantData(res);
      })
      .catch((err) => {
        console.error("Failed to load restaurant data:", err);
      });

    // Wait for BOTH the data AND a minimum 600ms so the intro doesn't flash
    Promise.all([dataPromise, new Promise((r) => setTimeout(r, 600))]).then(
      () => {
        setLoading(false);
        setShowIntro(false);
      }
    );
  }, []);
  return (
    <Router>
      <Switch>
        <Route
          path="/"
          exact
          render={(routeProps) => (
            <Home
              {...routeProps}
              restaurantData={restaurantData}
              loading={loading}
              showIntro={showIntro}
              onRestaurantDataRefresh={refreshRestaurantData}
            />
          )}
        />
      </Switch>
    </Router>
  );
}

export default App;
